import mitt from 'mitt'
import { defineNuxtPlugin } from '#app'

const instance = mitt()

instance.once = (ev: string, handler: (e: unknown) => void) => {
  const fn = (...args: any[]) => {
    instance.off(ev, fn)
    handler(args)
  }

  instance.on(ev, fn)
}

const root = {
  on: (ev: string, callback: (e: unknown) => void) => instance.on(ev, callback),
  off: (ev: string, callback?: (e: unknown) => void) => instance.off(ev, callback),
  emit: (ev: string, args?: any) => instance.emit(ev, args),
  once: (ev: string, callback?: (e: unknown) => void) => instance.once(ev, callback)
}

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      root: root
    }
  }
})
